import { useAppSnackbar } from '@/stores/app/snackbar';

export const handleKnownSettingsApiErrors = ({ context = '', error }) => {
  const prependedContext = context ? `${context} - ` : '';

  if (error.response?.code === 'not_allowed') {
    useAppSnackbar().addErrorSnackbar({
      text: `${prependedContext} You are not allowed to perform this action.`,
    });
    return true;
  }

  if (error.response?.code === 'validation_failed') {
    useAppSnackbar().addErrorSnackbar({
      text: `Validation failed: ${JSON.stringify(error.response.errors)}`,
    });
    return true;
  }

  return false;
};
